(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bxgy-banner"] && !Shopify.designMode) return;
  try {
    (function () {
        if (window.__bxgyBannerInit) return;
        window.__bxgyBannerInit = true;

        function parseJSON(id, fallback) {
          var el = document.getElementById(id);
          if (!el) return fallback;
          try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
        }

        var banner = document.getElementById('bxgy-banner');
        if (!banner) return;

        var bxgy = parseJSON('bxgy-config-data', null);
        var ladder = parseJSON('bxgy-ladder-data', {}) || {};
        var initialLines = parseJSON('bxgy-cart-lines', []) || [];
        var rewards = parseJSON('bxgy-reward-products', []) || [];

        if (!bxgy || !bxgy.tiers || !bxgy.tiers.length) return;

        var tiers = bxgy.tiers.slice().sort(function (a, b) {
          return (a.buyMeters || 0) - (b.buyMeters || 0);
        });

        var eligTypes = (ladder.eligibleProductTypes || []).map(function (t) {
          return String(t).toLowerCase();
        });
        var eligIds = (ladder.eligibleProductIds || []).map(function (g) {
          var m = String(g).match(/(\d+)\s*$/);
          return m ? m[1] : String(g);
        });

        // product_id -> free_gift_category, seeded from cart + reward products.
        var catMap = {};
        initialLines.forEach(function (l) {
          if (l.category) catMap[String(l.product_id)] = l.category;
        });
        rewards.forEach(function (r) {
          if (r.category) catMap[String(r.product_id)] = r.category;
        });

        var titleEl = document.getElementById('bxgy-banner-title');
        var subEl = document.getElementById('bxgy-banner-sub');
        var gridEl = document.getElementById('bxgy-banner-grid');

        // Backend-decided marketing copy for today's BASE tier (handles "free" vs "half
        // price" wording for tier 1 only). Only valid as the headline while the customer
        // hasn't earned any tier yet — once they're past tier 1, it stops describing their
        // actual position, so tier-earned states always show computed, tier-accurate text.
        var promoMsg = (bxgy.promoMessage || '').trim();
        // Title helper: promoMessage wins only when allowPromo (default true) and a tier
        // hasn't been earned yet; tier-earned states pass allowPromo=false explicitly.
        function setTitle(fallbackText, fallbackHtml, allowPromo) {
          if (allowPromo !== false && promoMsg) { titleEl.textContent = promoMsg; }
          else if (fallbackHtml) { titleEl.innerHTML = fallbackHtml; }
          else { titleEl.textContent = fallbackText; }
        }
        // "N free meters" or "N meters at X% off", from a tier's own rewardDiscountPercent
        function tierRewardHtml(count, tier) {
          var pct = (!tier || tier.rewardDiscountPercent === undefined || tier.rewardDiscountPercent === null)
            ? 100 : tier.rewardDiscountPercent;
          return (pct >= 100) ? fmt(count) + ' free ' + mUnit(count) : fmt(count) + ' ' + mUnit(count) + ' at ' + pct + '% off';
        }

        /* fractional cut pieces: SKU suffix "-2.5M" means 1 cart unit = 2.5 real meters */
        function getMetersPerUnit(sku) {
          if (!sku) return 1;
          var match = /-(\d+(?:\.\d+)?)M$/i.exec(sku);
          if (!match) return 1;
          var value = Number(match[1]);
          return isFinite(value) && value > 0 ? value : 1;
        }
        function getEffectiveMeters(line) {
          return (line.quantity || 0) * getMetersPerUnit(line.sku);
        }
        function fmt(n) {
          n = Math.round(n * 10) / 10;
          return n % 1 === 0 ? String(Math.round(n)) : String(n);
        }

        function isBuyEligible(line) {
          if (!eligTypes.length && !eligIds.length) return true;
          var t = String(line.product_type || '').toLowerCase();
          if (eligTypes.indexOf(t) !== -1) return true;
          if (eligIds.indexOf(String(line.product_id)) !== -1) return true;
          return false;
        }

        function findTier(totalBuy) {
          var match = null;
          for (var i = 0; i < tiers.length; i++) {
            if ((tiers[i].buyMeters || 0) <= totalBuy) match = tiers[i];
            else break;
          }
          return match;
        }

        function findNextTier(totalBuy) {
          for (var i = 0; i < tiers.length; i++) {
            if ((tiers[i].buyMeters || 0) > totalBuy) return tiers[i];
          }
          return null;
        }

        /*
         * Corrected entitlement (mirrors the updated Function): dual-eligible lines
         * (buy-eligible AND reward-eligible) that get given away for free no longer
         * count toward earning their own tier. When freeing them drops the PAID buy
         * total below the matched threshold, demote to the tier the paid amount
         * actually supports and re-allocate — repeating until stable.
         */
        function compute(lines) {
          var totalBuy = 0;
          var buyEligibleIdx = {};
          lines.forEach(function (l, i) {
            if (isBuyEligible(l)) {
              totalBuy += getEffectiveMeters(l);
              buyEligibleIdx[i] = true;
            }
          });

          var candidate = totalBuy;

          function teaserState() {
            // use candidate (current-pass, post-demotion paid value), not raw totalBuy —
            // otherwise a self-funded/demoted tier reports progress against the WRONG next
            // tier (skips the one that was just demoted away from).
            var n = findNextTier(candidate);
            if (!n) return null;
            return { tier: null, cats: [], free: 0, shortfall: 0, totalBuy: candidate, rawBuy: candidate, next: n };
          }
          for (var pass = 0; pass <= tiers.length; pass++) {
            var tier = findTier(candidate);
            if (!tier) return teaserState();

            var cats = tier.rewardCategories || [];
            var free = tier.freeMeters || 0;
            if (free <= 0 || !cats.length) return teaserState();

            // reward-eligible lines, cheapest PER EFFECTIVE METER first (Function order);
            // whole units only — a piece bigger than the remaining entitlement is skipped
            var rewardLines = lines.map(function (l, i) { return { i: i, l: l }; })
              .filter(function (e) {
                var c = catMap[String(e.l.product_id)];
                return c && cats.indexOf(c) !== -1;
              })
              .map(function (e) {
                var m = getMetersPerUnit(e.l.sku);
                return { i: e.i, quantity: e.l.quantity || 0, mpu: m, perMeter: (e.l.unit_price || 0) / m };
              })
              .sort(function (a, b) { return a.perMeter - b.perMeter; });

            var remaining = free;
            var dualFree = 0;
            for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
              var rl = rewardLines[r];
              var unitsAffordable = Math.floor(remaining / rl.mpu + 1e-9);
              var unitsToFree = Math.min(unitsAffordable, rl.quantity);
              if (unitsToFree <= 0) continue;
              var freed = unitsToFree * rl.mpu;
              remaining -= freed;
              if (buyEligibleIdx[rl.i]) dualFree += freed;
            }
            if (remaining < 0) remaining = 0;

            var paid = totalBuy - dualFree;
            if (paid >= (tier.buyMeters || 0) - 1e-9) {
              // stable — this is the real, applied entitlement
              var next = null;
              for (var t = 0; t < tiers.length; t++) {
                if ((tiers[t].buyMeters || 0) > (tier.buyMeters || 0)) { next = tiers[t]; break; }
              }
              // totalBuy(paid) drives entitlement; rawBuy drives the "meters to next tier"
              // progress line so it tracks the buy ladder and doesn't drift with reward qty
              return { tier: tier, cats: cats, free: free, shortfall: remaining, totalBuy: paid, rawBuy: totalBuy, next: next };
            }
            candidate = paid; // re-check against a lower tier
          }
          return teaserState();
        }

        function mUnit(n) { return n === 1 ? 'meter' : 'meters'; }

        function renderProgress(state) {
          var wrap = document.getElementById('bxgy-progress');
          var fill = document.getElementById('bxgy-fill');
          var label = document.getElementById('bxgy-progress-label');
          if (!wrap || !fill || !label) return;
          var next = state && state.next;
          if (!next) { wrap.hidden = true; return; }

          // raw buy-eligible total (not the demoted paid value) — progress along the buy ladder
          var buy = (state.rawBuy != null) ? state.rawBuy : state.totalBuy;

          var pct = (next.buyMeters || 0) > 0 ? (buy / next.buyMeters) * 100 : 0;
          if (pct < 0) pct = 0;
          if (pct > 96) pct = 96;
          fill.style.width = pct + '%';

          var need = (next.buyMeters || 0) - buy;
          // show the next tier's FULL reward (not the incremental delta over the current
          // tier), priced using that tier's own rewardDiscountPercent (default 100 = free)
          var nextFree = next.freeMeters || 0;
          var nextPct = (next.rewardDiscountPercent === undefined || next.rewardDiscountPercent === null)
            ? 100 : next.rewardDiscountPercent;
          var benefit = (nextPct >= 100)
            ? fmt(nextFree) + ' free ' + mUnit(nextFree)
            : fmt(nextFree) + ' ' + mUnit(nextFree) + ' at ' + nextPct + '% off';

          if (need >= 1) {
            label.innerHTML = '<span>Add <strong>' + fmt(need) + ' more ' + mUnit(need) +
              '</strong> to get <strong>' + benefit + '</strong> in total</span>' +
              '<span class="bxgy-banner__progress-count">' + fmt(buy) + ' / ' + fmt(next.buyMeters) + ' meters</span>';
          } else {
            // buy total already at/over the next threshold (e.g. dual-eligible overshoot)
            label.innerHTML = '<span>Add a few more meters to get <strong>' + benefit + '</strong> in total</span>';
          }
          wrap.hidden = false;
        }

        function hideNavs() {
          var pn = document.getElementById('bxgy-nav-prev');
          var nn = document.getElementById('bxgy-nav-next');
          if (pn) pn.hidden = true;
          if (nn) nn.hidden = true;
        }

        function render(state) {
          if (!state) {
            banner.hidden = true;
            return;
          }
          banner.classList.remove('bxgy-banner--claimed');
          banner.classList.remove('bxgy-banner--progress-only');

          if (!state.tier) {
            // below first tier — teaser with progress toward the first reward
            banner.classList.add('bxgy-banner--progress-only');
            setTitle('Free fabric offer');
            subEl.textContent = '';
            gridEl.innerHTML = '';
            hideNavs();
            renderProgress(state);
            banner.hidden = false;
            return;
          }
          if (state.shortfall <= 0) {
            // entitlement fully claimed — show confirmation instead of hiding
            banner.classList.add('bxgy-banner--claimed');
            setTitle('', "You've earned <strong>" + tierRewardHtml(state.free, state.tier) +
              '</strong> — already applied below', false);
            subEl.textContent = 'No code needed';
            gridEl.innerHTML = '';
            hideNavs();
            renderProgress(state);
            banner.hidden = false;
            return;
          }
          // whole meters actually claimable via 1m reward products
          var claimable = Math.floor(state.shortfall + 1e-9);
          if (claimable < 1) {
            // fractional remainder only — earned but nothing whole-unit addable
            banner.classList.add('bxgy-banner--progress-only');
            setTitle('', "You've earned <strong>" + tierRewardHtml(state.free, state.tier) +
              '</strong> — already applied below', false);
            gridEl.innerHTML = '';
            hideNavs();
            renderProgress(state);
            banner.hidden = false;
            return;
          }
          setTitle('', "You've unlocked <strong>" + tierRewardHtml(state.shortfall, state.tier) + '</strong>!', false);
          subEl.textContent = '';

          lastState = state;
          if (!renderRewardRow()) {
            // no reward products to suggest — fall back to progress teaser
            banner.classList.add('bxgy-banner--progress-only');
            setTitle('', "You've unlocked <strong>" + tierRewardHtml(state.shortfall, state.tier) + '</strong>!', false);
            gridEl.innerHTML = '';
            hideNavs();
          }
          renderProgress(state);
          banner.hidden = false;
        }

        /* ── filterable reward row: Plain (default) / Digital Printed (poly+pure) / All ── */
        var lastState = null;
        var rewardFilter = 'plain';

        function rewardBuckets(state) {
          var byCat = {};
          rewards.forEach(function (r) {
            // only whole-meter variants are offered as rewards (no fractional cut pieces)
            if (!r.available || getMetersPerUnit(r.sku) !== 1) return;
            if (state.cats.indexOf(r.category) === -1) return;
            (byCat[r.category] = byCat[r.category] || []).push(r);
          });
          // each category sorted price low -> high
          Object.keys(byCat).forEach(function (c) {
            byCat[c].sort(function (a, b) { return (a.price || 0) - (b.price || 0); });
          });
          return byCat;
        }

        // take `size` at a time from each category in order, cycling until all exhausted
        function chunkRobin(buckets, cats, size) {
          var pos = {};
          cats.forEach(function (c) { pos[c] = 0; });
          var out = [];
          for (;;) {
            var added = false;
            for (var i = 0; i < cats.length; i++) {
              var c = cats[i], b = buckets[c] || [], taken = 0;
              while (pos[c] < b.length && taken < size) { out.push(b[pos[c]++]); taken++; added = true; }
            }
            if (!added) break;
          }
          return out;
        }

        function renderRewardRow() {
          if (!lastState) return false;
          var byCat = rewardBuckets(lastState);
          var plainItems = byCat['plain'] || [];
          // Digital Printed: all poly (price asc) then all pure (price asc)
          var digitalItems = (byCat['poly'] || []).concat(byCat['pure'] || []);

          // show each pill only when its group is eligible; hide the row unless there
          // are 2+ groups to switch between (e.g. plain-only tier shows no pills)
          var hasPlain = plainItems.length > 0;
          var hasDigital = digitalItems.length > 0;
          var pillsEl = document.getElementById('bxgy-pills');
          if (pillsEl) {
            pillsEl.querySelectorAll('.bxgy-pill').forEach(function (b) {
              var pf = b.dataset.filter;
              var on = (pf === 'plain' && hasPlain) ||
                       (pf === 'digital' && hasDigital) ||
                       (pf === 'all' && hasPlain && hasDigital);
              b.hidden = !on;
            });
            pillsEl.hidden = !(hasPlain && hasDigital);
          }

          var f = rewardFilter;
          if (f === 'plain' && !hasPlain) f = 'digital';
          if (f === 'digital' && !hasDigital) f = 'plain';
          if (f === 'all' && !(hasPlain && hasDigital)) f = hasPlain ? 'plain' : 'digital';

          var items;
          if (f === 'all') {
            // mix-and-match: 3 plain, then 3 poly, then 3 pure, repeat
            var allOrder = ['plain', 'poly', 'pure'].filter(function (c) { return byCat[c] && byCat[c].length; });
            items = chunkRobin(byCat, allOrder, 3);
          } else if (f === 'digital') {
            items = digitalItems;
          } else {
            items = plainItems;
          }

          if (pillsEl) {
            pillsEl.querySelectorAll('.bxgy-pill').forEach(function (b) {
              b.classList.toggle('is-active', b.dataset.filter === f);
            });
          }

          if (!items.length) return false;

          var n = Math.floor(lastState.shortfall + 1e-9);
          gridEl.innerHTML = '';
          items.forEach(function (r) {
            var card = document.createElement('div');
            card.className = 'bxgy-card';
            var media = '';
            if (r.image) {
              media = '<div class="bxgy-card__media"><img src="' + r.image +
                '" alt="" loading="lazy" width="160" height="160"></div>';
            }
            card.innerHTML = media +
              '<div class="bxgy-card__body">' +
                '<a class="bxgy-card__title" href="' + r.url + '">' + escapeHtml(r.title) + '</a>' +
                '<div class="bxgy-card__qty">' +
                  '<button type="button" class="bxgy-card__qty-btn" data-action="minus" aria-label="Less">−</button>' +
                  '<span class="bxgy-card__qty-box"><input type="number" class="bxgy-card__qty-input" value="1" min="1" max="' + n + '" inputmode="numeric" aria-label="Free meters to add"><span class="bxgy-card__qty-suffix">m</span></span>' +
                  '<button type="button" class="bxgy-card__qty-btn" data-action="plus" aria-label="More">+</button>' +
                '</div>' +
                '<button type="button" class="bxgy-card__add" data-variant="' + r.variant_id +
                  '" data-qty="' + n + '">Add 1m</button>' +
              '</div>';
            gridEl.appendChild(card);
          });

          gridEl.scrollLeft = 0;
          requestAnimationFrame(function () {
            var prev = document.getElementById('bxgy-nav-prev');
            var next = document.getElementById('bxgy-nav-next');
            if (!prev || !next) return;
            var max = gridEl.scrollWidth - gridEl.clientWidth;
            prev.hidden = true;
            next.hidden = max <= 4;
          });
          return true;
        }

        function escapeHtml(s) {
          return String(s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
          });
        }

        function linesFromCart(cart) {
          return (cart.items || []).map(function (it) {
            return {
              product_id: it.product_id,
              product_type: it.product_type,
              quantity: it.quantity,
              unit_price: it.final_price,
              sku: it.sku
            };
          });
        }

        function recompute(lines) {
          render(compute(lines));
        }

        gridEl.addEventListener('change', function (e) {
          if (e.target.classList.contains('bxgy-card__qty-input')) clampCardQty(e.target);
        });

        function clampCardQty(input) {
          var max = parseInt(input.getAttribute('max'), 10) || 1;
          var v = parseInt(input.value, 10);
          if (isNaN(v) || v < 1) v = 1;
          if (v > max) v = max;
          input.value = v;
          var card = input.closest('.bxgy-card');
          var addBtn = card ? card.querySelector('.bxgy-card__add') : null;
          if (addBtn && !addBtn.disabled) addBtn.textContent = 'Add ' + v + 'm';
          return v;
        }

        // per-card qty stepper (default = full shortfall) + add, capped at shortfall
        gridEl.addEventListener('click', function (e) {
          var qbtn = e.target.closest('.bxgy-card__qty-btn');
          if (qbtn) {
            var qinput = qbtn.parentElement.querySelector('.bxgy-card__qty-input');
            var cur = parseInt(qinput.value, 10) || 1;
            qinput.value = qbtn.dataset.action === 'plus' ? cur + 1 : cur - 1;
            clampCardQty(qinput);
            return;
          }

          var btn = e.target.closest('.bxgy-card__add');
          if (!btn || btn.disabled) return;
          var variant = btn.getAttribute('data-variant');
          var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
          var cardInput = btn.parentElement.querySelector('.bxgy-card__qty-input');
          if (cardInput) qty = clampCardQty(cardInput);
          btn.disabled = true;
          btn.textContent = 'Adding…';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variant, 10), quantity: qty })
          })
            .then(function () { return fetch('/cart.js'); })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            })
            .catch(function () { window.location.reload(); });
        });

        // filter pills — swap the reward row without touching the rest of the banner
        var pillsWrap = document.getElementById('bxgy-pills');
        if (pillsWrap) {
          pillsWrap.addEventListener('click', function (e) {
            var pill = e.target.closest('.bxgy-pill');
            if (!pill) return;
            rewardFilter = pill.dataset.filter;
            renderRewardRow();
          });
        }

        // carousel arrows (desktop; mobile uses swipe)
        var prevBtn = document.getElementById('bxgy-nav-prev');
        var nextBtn = document.getElementById('bxgy-nav-next');
        function syncNav() {
          if (!prevBtn || !nextBtn) return;
          var max = gridEl.scrollWidth - gridEl.clientWidth;
          prevBtn.hidden = gridEl.scrollLeft <= 4;
          nextBtn.hidden = gridEl.scrollLeft >= max - 4;
        }
        if (prevBtn && nextBtn) {
          prevBtn.addEventListener('click', function () {
            gridEl.scrollBy({ left: -gridEl.clientWidth * 0.8, behavior: 'smooth' });
          });
          nextBtn.addEventListener('click', function () {
            gridEl.scrollBy({ left: gridEl.clientWidth * 0.8, behavior: 'smooth' });
          });
          gridEl.addEventListener('scroll', syncNav, { passive: true });
          window.addEventListener('resize', syncNav);
        }

        // recompute whenever the cart changes (theme fires this on add/remove/qty)
        document.addEventListener('cart:updated', function (e) {
          var cart = e && e.detail;
          if (cart && cart.items) recompute(linesFromCart(cart));
        });

        // ── daily-offer countdown against validUntil (ISO w/ +05:30 offset — Date parses IST) ──
        // merchant control: "always" or "peak_only" (only when bxgy_config.isPeak is true)
        var cdEl = document.getElementById('bxgy-countdown');
        var countdownMode = banner.getAttribute('data-countdown-mode') || 'always';
        var countdownAllowed = countdownMode !== 'peak_only' || bxgy.isPeak === true;
        var validUntil = (countdownAllowed && bxgy.validUntil) ? new Date(bxgy.validUntil) : null;
        function pad2(n) { return n < 10 ? '0' + n : '' + n; }
        function renderCountdown() {
          if (!cdEl || !validUntil || isNaN(validUntil.getTime())) { if (cdEl) cdEl.hidden = true; return; }
          var diff = validUntil.getTime() - Date.now();
          if (diff <= 0) { cdEl.hidden = true; if (cdTimer) { clearInterval(cdTimer); cdTimer = null; } return; }
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var s = Math.floor((diff % 60000) / 1000);
          cdEl.textContent = 'Ends in ' + (h > 0 ? h + 'h ' + pad2(m) + 'm ' : m + 'm ') + pad2(s) + 's';
          cdEl.hidden = false;
        }
        var cdTimer = null;
        if (validUntil && !isNaN(validUntil.getTime())) {
          renderCountdown();
          cdTimer = setInterval(renderCountdown, 1000);
        }

        recompute(initialLines);
      })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bxgy-reward-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.getElementById('bxgy-reward');
    var promoMsg = box ? (box.getAttribute('data-promo') || '').trim() : '';
    if (!box) return;

    function parseJSON(id, fb) {
      var el = document.getElementById(id);
      if (!el) return fb;
      try { return JSON.parse(el.textContent); } catch (e) { return fb; }
    }

    var tiers = (parseJSON('bxgy-reward-tiers', []) || []).slice().sort(function (a, b) {
      return (a.buyMeters || 0) - (b.buyMeters || 0);
    });
    if (!tiers.length) return;
    var ladder = parseJSON('bxgy-reward-ladder', {}) || {};
    var cartLines = parseJSON('bxgy-reward-cart', []) || [];
    var variants = parseJSON('bxgy-reward-variants', []) || [];

    var eligTypes = (ladder.eligibleProductTypes || []).map(function (t) { return String(t).toLowerCase(); });
    var eligIds = (ladder.eligibleProductIds || []).map(function (g) {
      var m = String(g).match(/(\d+)\s*$/);
      return m ? m[1] : String(g);
    });

    function mpu(sku) {
      if (!sku) return 1;
      var m = /-(\d+(?:\.\d+)?)M$/i.exec(sku);
      if (!m) return 1;
      var v = Number(m[1]);
      return isFinite(v) && v > 0 ? v : 1;
    }
    function fmt(n) {
      n = Math.round(n * 10) / 10;
      return n % 1 === 0 ? String(Math.round(n)) : String(n);
    }
    function mUnit(n) { return n === 1 ? 'meter' : 'meters'; }
    // full tier reward, priced via that tier's own rewardDiscountPercent (default 100 = free)
    function tierBenefitHtml(t) {
      var free = t.freeMeters || 0;
      var pct = (t.rewardDiscountPercent === undefined || t.rewardDiscountPercent === null) ? 100 : t.rewardDiscountPercent;
      return (pct >= 100) ? fmt(free) + ' free ' + mUnit(free) : fmt(free) + ' ' + mUnit(free) + ' at ' + pct + '% off';
    }

    var pageProduct = parseJSON('bxgy-reward-product', {}) || {};

    var catMap = {};
    cartLines.forEach(function (l) {
      if (l.category) catMap[String(l.product_id)] = l.category;
    });
    if (pageProduct.category) catMap[String(pageProduct.product_id)] = pageProduct.category;

    function isBuyEligible(l) {
      if (!eligTypes.length && !eligIds.length) return true;
      var t = String(l.product_type || '').toLowerCase();
      return eligTypes.indexOf(t) !== -1 || eligIds.indexOf(String(l.product_id)) !== -1;
    }
    function eff(l) { return (l.quantity || 0) * mpu(l.sku); }
    function findTier(b) {
      var m = null;
      for (var i = 0; i < tiers.length; i++) {
        if ((tiers[i].buyMeters || 0) <= b) m = tiers[i];
        else break;
      }
      return m;
    }
    function findNextTier(b) {
      for (var i = 0; i < tiers.length; i++) {
        if ((tiers[i].buyMeters || 0) > b) return tiers[i];
      }
      return null;
    }

    // Same corrected entitlement as the cart banner / Function: dual-eligible lines
    // freed as rewards don't count toward earning their own tier — demote until stable.
    function compute(lines) {
      var totalBuy = 0;
      var buyIdx = {};
      lines.forEach(function (l, i) {
        if (isBuyEligible(l)) { totalBuy += eff(l); buyIdx[i] = true; }
      });

      var candidate = totalBuy;

      function teaserState() {
        var n = findNextTier(candidate);
        if (!n) return null;
        return { tier: null, free: 0, totalBuy: candidate, rawBuy: candidate, next: n };
      }
      for (var pass = 0; pass <= tiers.length; pass++) {
        var tier = findTier(candidate);
        if (!tier) return teaserState();
        var cats = tier.rewardCategories || [];
        var free = tier.freeMeters || 0;
        if (free <= 0 || !cats.length) return teaserState();

        var rewardLines = lines.map(function (l, i) { return { i: i, l: l }; })
          .filter(function (e) {
            var c = catMap[String(e.l.product_id)];
            return c && cats.indexOf(c) !== -1;
          })
          .map(function (e) {
            var m = mpu(e.l.sku);
            return { i: e.i, quantity: e.l.quantity || 0, mpu: m, perMeter: (e.l.unit_price || 0) / m };
          })
          .sort(function (a, b) { return a.perMeter - b.perMeter; });

        var remaining = free;
        var dualFree = 0;
        for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
          var rl = rewardLines[r];
          var ua = Math.floor(remaining / rl.mpu + 1e-9);
          var uf = Math.min(ua, rl.quantity);
          if (uf <= 0) continue;
          var freed = uf * rl.mpu;
          remaining -= freed;
          if (buyIdx[rl.i]) dualFree += freed;
        }
        var paid = totalBuy - dualFree;
        if (paid >= (tier.buyMeters || 0) - 1e-9) {
          var next = null;
          for (var t = 0; t < tiers.length; t++) {
            if ((tiers[t].buyMeters || 0) > (tier.buyMeters || 0)) { next = tiers[t]; break; }
          }
          return { tier: tier, free: free, totalBuy: paid, rawBuy: totalBuy, next: next };
        }
        candidate = paid;
      }
      return teaserState();
    }

    function currentVariant() {
      var form = document.getElementById('product-form');
      var inp = form ? form.querySelector('input[name="id"]') : null;
      if (!inp) return null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(inp.value)) return variants[i];
      }
      return null;
    }

    function pageQty() {
      var mi = document.getElementById('meter-input');
      var q = mi ? parseInt(mi.value, 10) : 1;
      return isNaN(q) || q < 1 ? 1 : q;
    }

    var headlineEl = document.getElementById('bxgy-reward-headline');
    var nextEl = document.getElementById('bxgy-reward-next');
    var fillEl = document.getElementById('bxgy-reward-fill');

    // Always forward-pointing: "Add N more meters" / "to get M meters at X% off" —
    // never states what's already in the cart, just the next unlockable reward,
    // whether or not a lower tier has already been earned.
    function render() {
      var v = currentVariant();
      var pageLine = {
        product_id: pageProduct.product_id,
        product_type: pageProduct.product_type,
        quantity: pageQty(),
        unit_price: v ? (v.price || 0) : 0,
        sku: v ? (v.sku || '') : ''
      };

      var allState = compute(cartLines.concat([pageLine]));
      if (!allState) { box.hidden = true; return; }

      var tier = allState.tier;
      var next = allState.next;
      var buy = (allState.rawBuy != null) ? allState.rawBuy : allState.totalBuy;

      var headline = '';
      var subtext = '';
      var goal = 0;
      var pct = 0;

      if (next) {
        // raw buy can overshoot next.buyMeters when a reward-eligible line is also
        // buy-eligible (self-funding) — the true qualifying amount is still catching
        // up, so a precise "0" here would be wrong; show the same vague fallback
        // bxgy-banner.liquid uses for this exact overshoot case instead of "Add 0".
        var remaining = (next.buyMeters || 0) - buy;
        headline = remaining >= 1
          ? '🎁 Add ' + fmt(remaining) + ' more ' + mUnit(remaining)
          : '🎁 Add a few more meters';
        subtext = 'to get ' + tierBenefitHtml(next);
        goal = next.buyMeters || 0;
        pct = goal > 0 ? Math.min(96, (buy / goal) * 100) : 0;
      } else if (tier && (tier.freeMeters || 0) > 0) {
        headline = "🎁 You've unlocked " + tierBenefitHtml(tier) + ' 🎉';
        subtext = '';
        pct = 100;
      } else {
        box.hidden = true;
        return;
      }

      headlineEl.innerHTML = headline;
      nextEl.textContent = subtext;
      fillEl.style.width = pct + '%';
      box.hidden = false;
    }

    // Frozen by design: the target does NOT react to stepper/quantity changes on the
    // page (unlike the design spec's "must recompute live" requirement) — only a real
    // add-to-cart (cart:added) or cart change (cart:updated) refreshes it, so the number
    // stays stable while the customer is still deciding a quantity.
    document.addEventListener('cart:added', function (e) {
      var it = e && e.detail;
      if (!it) return;
      cartLines.push({
        product_id: it.product_id,
        product_type: it.product_type,
        quantity: it.quantity,
        unit_price: it.final_price || it.price || 0,
        sku: it.sku
      });
      render();
    });
    document.addEventListener('cart:updated', function (e) {
      var cart = e && e.detail;
      if (cart && cart.items) {
        cartLines = cart.items.map(function (it) {
          return { product_id: it.product_id, product_type: it.product_type, quantity: it.quantity, unit_price: it.final_price, sku: it.sku };
        });
      }
      render();
    });

    render();

    // ── daily-offer countdown against validUntil (ISO w/ +05:30 offset — Date parses IST) ──
    // two layers of control: this block's own "Show countdown timer" checkbox (manual
    // override, checked first) AND the global "always"/"peak_only" theme setting.
    (function () {
      var cdEl = document.getElementById('bxgy-reward-countdown');
      var raw = box.getAttribute('data-valid-until');
      var blockEnabled = box.getAttribute('data-block-countdown') !== 'false';
      var countdownMode = box.getAttribute('data-countdown-mode') || 'always';
      var isPeak = box.getAttribute('data-is-peak') === 'true';
      if (!cdEl || !raw) return;
      if (!blockEnabled) { cdEl.hidden = true; return; }
      if (countdownMode === 'peak_only' && !isPeak) { cdEl.hidden = true; return; }
      var validUntil = new Date(raw);
      if (isNaN(validUntil.getTime())) return;
      function pad2(n) { return n < 10 ? '0' + n : '' + n; }
      var timer = null;
      function tick() {
        var diff = validUntil.getTime() - Date.now();
        if (diff <= 0) { cdEl.hidden = true; if (timer) clearInterval(timer); return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        cdEl.textContent = '⏱ ' + pad2(h) + ':' + pad2(m) + ':' + pad2(s);
        cdEl.hidden = false;
      }
      tick();
      timer = setInterval(tick, 1000);
    })();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bxgy-teaser"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.getElementById('bxgy-teaser');
    var promoMsg = box ? (box.getAttribute('data-promo') || '').trim() : '';
    if (!box) return;

    function parseJSON(id, fb) {
      var el = document.getElementById(id);
      if (!el) return fb;
      try { return JSON.parse(el.textContent); } catch (e) { return fb; }
    }

    var tiers = (parseJSON('bxgy-teaser-tiers', []) || []).slice().sort(function (a, b) {
      return (a.buyMeters || 0) - (b.buyMeters || 0);
    });
    if (!tiers.length) return;
    var ladder = parseJSON('bxgy-teaser-ladder', {}) || {};
    var cartLines = parseJSON('bxgy-teaser-cart', []) || [];
    var variants = parseJSON('bxgy-teaser-variants', []) || [];

    var eligTypes = (ladder.eligibleProductTypes || []).map(function (t) { return String(t).toLowerCase(); });
    var eligIds = (ladder.eligibleProductIds || []).map(function (g) {
      var m = String(g).match(/(\d+)\s*$/);
      return m ? m[1] : String(g);
    });

    function mpu(sku) {
      if (!sku) return 1;
      var m = /-(\d+(?:\.\d+)?)M$/i.exec(sku);
      if (!m) return 1;
      var v = Number(m[1]);
      return isFinite(v) && v > 0 ? v : 1;
    }
    function fmt(n) {
      n = Math.round(n * 10) / 10;
      return n % 1 === 0 ? String(Math.round(n)) : String(n);
    }
    function mUnit(n) { return n === 1 ? 'meter' : 'meters'; }
    // full tier reward, priced via that tier's own rewardDiscountPercent (default 100 = free)
    function tierBenefitHtml(t) {
      var free = t.freeMeters || 0;
      var pct = (t.rewardDiscountPercent === undefined || t.rewardDiscountPercent === null) ? 100 : t.rewardDiscountPercent;
      return (pct >= 100) ? fmt(free) + ' free ' + mUnit(free) : fmt(free) + ' ' + mUnit(free) + ' at ' + pct + '% off';
    }

    var pageProduct = parseJSON('bxgy-teaser-product', {}) || {};

    // product_id -> free_gift_category, seeded from cart + this product
    var catMap = {};
    cartLines.forEach(function (l) {
      if (l.category) catMap[String(l.product_id)] = l.category;
    });
    if (pageProduct.category) catMap[String(pageProduct.product_id)] = pageProduct.category;

    function isBuyEligible(l) {
      if (!eligTypes.length && !eligIds.length) return true;
      var t = String(l.product_type || '').toLowerCase();
      return eligTypes.indexOf(t) !== -1 || eligIds.indexOf(String(l.product_id)) !== -1;
    }
    function eff(l) { return (l.quantity || 0) * mpu(l.sku); }
    function findTier(b) {
      var m = null;
      for (var i = 0; i < tiers.length; i++) {
        if ((tiers[i].buyMeters || 0) <= b) m = tiers[i];
        else break;
      }
      return m;
    }
    function findNextTier(b) {
      for (var i = 0; i < tiers.length; i++) {
        if ((tiers[i].buyMeters || 0) > b) return tiers[i];
      }
      return null;
    }

    // Same corrected entitlement as the cart banner / Function: dual-eligible lines
    // freed as rewards don't count toward earning their own tier — demote until stable.
    function compute(lines) {
      var totalBuy = 0;
      var buyIdx = {};
      lines.forEach(function (l, i) {
        if (isBuyEligible(l)) { totalBuy += eff(l); buyIdx[i] = true; }
      });

      var candidate = totalBuy;

      function teaserState() {
        // candidate = current-pass post-demotion paid value, not raw totalBuy —
        // else a demoted tier reports progress against the wrong (too-high) next tier.
        var n = findNextTier(candidate);
        if (!n) return null;
        return { tier: null, free: 0, totalBuy: candidate, rawBuy: candidate, next: n };
      }
      for (var pass = 0; pass <= tiers.length; pass++) {
        var tier = findTier(candidate);
        if (!tier) return teaserState();
        var cats = tier.rewardCategories || [];
        var free = tier.freeMeters || 0;
        if (free <= 0 || !cats.length) return teaserState();

        var rewardLines = lines.map(function (l, i) { return { i: i, l: l }; })
          .filter(function (e) {
            var c = catMap[String(e.l.product_id)];
            return c && cats.indexOf(c) !== -1;
          })
          .map(function (e) {
            var m = mpu(e.l.sku);
            return { i: e.i, quantity: e.l.quantity || 0, mpu: m, perMeter: (e.l.unit_price || 0) / m };
          })
          .sort(function (a, b) { return a.perMeter - b.perMeter; });

        var remaining = free;
        var dualFree = 0;
        for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
          var rl = rewardLines[r];
          var ua = Math.floor(remaining / rl.mpu + 1e-9);
          var uf = Math.min(ua, rl.quantity);
          if (uf <= 0) continue;
          var freed = uf * rl.mpu;
          remaining -= freed;
          if (buyIdx[rl.i]) dualFree += freed;
        }
        var paid = totalBuy - dualFree;
        if (paid >= (tier.buyMeters || 0) - 1e-9) {
          var next = null;
          for (var t = 0; t < tiers.length; t++) {
            if ((tiers[t].buyMeters || 0) > (tier.buyMeters || 0)) { next = tiers[t]; break; }
          }
          return { tier: tier, free: free, totalBuy: paid, rawBuy: totalBuy, next: next };
        }
        candidate = paid;
      }
      return teaserState();
    }

    function currentVariant() {
      var form = document.getElementById('product-form');
      var inp = form ? form.querySelector('input[name="id"]') : null;
      if (!inp) return null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(inp.value)) return variants[i];
      }
      return null;
    }

    function pageQty() {
      var mi = document.getElementById('meter-input');
      var q = mi ? parseInt(mi.value, 10) : 1;
      return isNaN(q) || q < 1 ? 1 : q;
    }

    var textEl = document.getElementById('bxgy-teaser-text');
    var fillEl = document.getElementById('bxgy-teaser-fill');

    function render() {
      var v = currentVariant();
      var pageLine = {
        product_id: pageProduct.product_id,
        product_type: pageProduct.product_type,
        quantity: pageQty(),
        unit_price: v ? (v.price || 0) : 0,
        sku: v ? (v.sku || '') : ''
      };

      var allState = compute(cartLines.concat([pageLine]));
      var cartState = compute(cartLines);

      var nextEl = document.getElementById('bxgy-teaser-next');
      var html = '';
      var nextHtml = '';

      if (!allState) { box.hidden = true; return; }

      var tier = allState.tier;
      var next = allState.next;
      var paid = allState.totalBuy;
      // raw buy-eligible total drives the "meters to next tier" progress (not the demoted paid)
      var buy = (allState.rawBuy != null) ? allState.rawBuy : paid;

      if (tier && (tier.freeMeters || 0) > 0) {
        // "earned" only when the cart ALONE already secures this tier (corrected calc)
        var earned = cartState && cartState.tier && (cartState.tier.buyMeters || 0) >= (tier.buyMeters || 0);
        var cta = earned ? ' — <a href="/cart">claim it in cart</a>' : ' — add to cart to claim';
        // promoMessage describes today's BASE tier only — once a tier is earned it stops
        // matching the customer's real position, so use computed tier-accurate text instead.
        var earnBit = '<strong>' + tierBenefitHtml(tier) + '</strong>';
        html = (earned ? "You've earned " : 'This order unlocks ') + earnBit + cta;
        if (next) {
          var need = (next.buyMeters || 0) - buy;
          var nextBenefit = tierBenefitHtml(next);
          if (need >= 1) {
            nextHtml = 'Add <strong>' + fmt(need) + ' more ' + mUnit(need) + '</strong> to get <strong>' +
              nextBenefit + '</strong> in total';
          } else {
            nextHtml = 'Add a few more meters to get <strong>' + nextBenefit + '</strong> in total';
          }
        }
      } else if (next) {
        var firstNeed = (next.buyMeters || 0) - buy;
        html = (promoMsg ? promoMsg + ' — ' : '') + fmt(buy) + ' / ' + fmt(next.buyMeters) + ' meters, add <strong>' +
          fmt(firstNeed) + ' more ' + mUnit(firstNeed) +
          '</strong> to get <strong>' + tierBenefitHtml(next) + '</strong> in total';
      } else {
        box.hidden = true;
        return;
      }

      textEl.innerHTML = html;
      if (nextEl) {
        nextEl.innerHTML = nextHtml;
        nextEl.hidden = !nextHtml;
      }
      var goal = next ? next.buyMeters : (tier ? tier.buyMeters : 0);
      var pct = goal > 0 ? (buy / goal) * 100 : 100;
      if (next && pct > 96) pct = 96;
      if (pct > 100) pct = 100;
      fillEl.style.width = pct + '%';
      box.hidden = false;
    }

    // live with the page: qty stepper, variant switch, and cart updates when available
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.id === 'meter-input' || e.target.name === 'id')) render();
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#qty-minus, #qty-plus')) setTimeout(render, 0);
    });
    document.addEventListener('cart:added', function (e) {
      var it = e && e.detail;
      if (!it) return;
      cartLines.push({
        product_id: it.product_id,
        product_type: it.product_type,
        quantity: it.quantity,
        unit_price: it.final_price || it.price || 0,
        sku: it.sku
      });
      render();
    });
    document.addEventListener('cart:updated', function (e) {
      var cart = e && e.detail;
      if (cart && cart.items) {
        cartLines = cart.items.map(function (it) {
          return { product_id: it.product_id, product_type: it.product_type, quantity: it.quantity, unit_price: it.final_price, sku: it.sku };
        });
      }
      render();
    });

    render();

    // ── daily-offer countdown against validUntil (ISO w/ +05:30 offset — Date parses IST) ──
    // merchant control: "always" or "peak_only" (only when bxgy_config.isPeak is true)
    (function () {
      var cdEl = document.getElementById('bxgy-teaser-countdown');
      var raw = box.getAttribute('data-valid-until');
      var countdownMode = box.getAttribute('data-countdown-mode') || 'always';
      var isPeak = box.getAttribute('data-is-peak') === 'true';
      if (!cdEl || !raw) return;
      if (countdownMode === 'peak_only' && !isPeak) { cdEl.hidden = true; return; }
      var validUntil = new Date(raw);
      if (isNaN(validUntil.getTime())) return;
      function pad2(n) { return n < 10 ? '0' + n : '' + n; }
      var timer = null;
      function tick() {
        var diff = validUntil.getTime() - Date.now();
        if (diff <= 0) { cdEl.hidden = true; if (timer) clearInterval(timer); return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        cdEl.textContent = 'Ends in ' + (h > 0 ? h + 'h ' + pad2(m) + 'm ' : m + 'm ') + pad2(s) + 's';
        cdEl.hidden = false;
      }
      tick();
      timer = setInterval(tick, 1000);
    })();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-added-toast"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cartAdded) return;

    var toast = document.getElementById('cart-toast');
    var imgEl = document.getElementById('cart-toast-img');
    var titleEl = document.getElementById('cart-toast-title');
    var hideTimer = null;

    function syncCount() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var els = document.querySelectorAll('.header__cart-count, [data-cart-count]');
          els.forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? '' : 'none';
            el.classList.remove('is-bumped');
            void el.offsetWidth;
            el.classList.add('is-bumped');
          });
        })
        .catch(function () {});
    }

    function show(item) {
      if (!toast) { syncCount(); return; }
      if (item) {
        var img = item.image || item.featured_image || (item.featured_image && item.featured_image.url) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        if (img) { imgEl.src = img.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1'); imgEl.style.display = ''; }
        else { imgEl.style.display = 'none'; }
        titleEl.textContent = item.product_title || item.title || 'Item';
      }
      toast.classList.add('is-visible');
      toast.setAttribute('aria-hidden', 'false');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, 3200);
      syncCount();
    }

    function hide() {
      if (!toast) return;
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    }

    // Unified add-to-cart hook — every add path calls this.
    window.__cartAdded = show;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    function __initCartDrawer() {
    if (window.__cartDrawerInit) return;
    window.__cartDrawerInit = true;

    var el = document.getElementById('cart-drawer');
    if (!el) return;

    var body = document.getElementById('cd-body');
    var itemsWrap = document.getElementById('cd-items');
    var emptyEl = document.getElementById('cd-empty');
    var footerEl = document.getElementById('cd-footer');
    var countEl = document.getElementById('cd-count');
    var subtotalEl = document.getElementById('cd-subtotal');
    var savingsEl = document.getElementById('cd-savings');
    var shipMsg = document.getElementById('cd-ship-msg');
    var shipFill = document.getElementById('cd-ship-fill');
    var shipBar = document.getElementById('cd-ship-bar');
    var upsellWrap = document.getElementById('cd-upsell');
    var upsellScroll = document.getElementById('cd-upsell-scroll');
    var scrollHint = document.getElementById('cd-scroll-hint');
    var scrollHintText = document.getElementById('cd-scroll-hint-text');
    var scrollSections = document.getElementById('cd-scroll-sections');
    var discountToggle = document.getElementById('cd-discount-toggle');
    var discountForm = document.getElementById('cd-discount-form');
    var discountInput = document.getElementById('cd-discount-input');
    var discountApply = document.getElementById('cd-discount-apply');
    var discountMsg = document.getElementById('cd-discount-msg');
    var discountWrap = document.getElementById('cd-discount');

    var popup = document.getElementById('cd-remove-popup');
    var popupImg = document.getElementById('cd-popup-img');
    var popupTitle = document.getElementById('cd-popup-title');
    var popupWishlist = document.getElementById('cd-popup-wishlist');
    var popupRemove = document.getElementById('cd-popup-remove');
    var pendingRemoveKey = null;
    var pendingRemoveHandle = null;

    var FREE_SHIP_THRESHOLD = 99900;
    var debounceTimer = null;
    var cartCache = null;

    function formatMoney(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    // Pull the same server-rendered line items the cart page uses, so the two can't drift.
    function renderSharedItems() {
      var params = new URLSearchParams(window.location.search);
      params.set('section_id', 'cart-items');
      fetch(window.location.pathname + '?' + params.toString(), { credentials: 'same-origin' })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var rendered = doc.getElementById('cart-items-render');
          if (rendered) itemsWrap.innerHTML = rendered.innerHTML;
        })
        .catch(function() {});
    }

    // cart-items.js performs line-item mutations and fires this; only re-render if we're open.
    document.addEventListener('cart:updated', function(e) {
      if (el && el.classList.contains('is-open')) renderItems(e.detail);
    });

    function open() {
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      refreshCart();
    }

    function close() {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function showRemovePopup(key, title, imgSrc, handle) {
      pendingRemoveKey = key;
      pendingRemoveHandle = handle;
      popupTitle.textContent = title;
      popupImg.src = imgSrc || '';
      popup.style.display = '';
      requestAnimationFrame(function() {
        popup.classList.add('is-visible');
      });
    }

    function hideRemovePopup() {
      popup.classList.remove('is-visible');
      setTimeout(function() { popup.style.display = 'none'; }, 200);
      pendingRemoveKey = null;
      pendingRemoveHandle = null;
    }

    function updateShipBar(total) {
      if (FREE_SHIP_THRESHOLD <= 0) { shipBar.style.display = 'none'; return; }
      var remaining = FREE_SHIP_THRESHOLD - total;
      var pct = Math.min(100, (total / FREE_SHIP_THRESHOLD) * 100);
      shipFill.style.width = pct + '%';
      if (remaining <= 0) {
        shipMsg.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg> You qualify for <strong style="color:var(--color-gold)">free shipping!</strong>';
        shipFill.classList.add('is-complete');
      } else {
        shipMsg.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--color-gold)" stroke-width="1.5"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8l5 3-5 3V8z"/></svg> Add <strong style="color:var(--color-gold)">' + formatMoney(remaining) + '</strong> more for free shipping';
        shipFill.classList.remove('is-complete');
      }
    }

    function renderItems(cart) {
      cartCache = cart;
      countEl.textContent = '(' + cart.item_count + ')';

      var headerCount = document.querySelector('.header__cart-count');
      if (headerCount) {
        headerCount.textContent = cart.item_count;
        headerCount.style.display = cart.item_count > 0 ? '' : 'none';
      }

      if (cart.item_count === 0) {
        itemsWrap.innerHTML = '';
        emptyEl.style.display = '';
        footerEl.style.display = 'none';
        if (scrollSections) scrollSections.style.display = 'none';
        if (scrollHint) scrollHint.style.display = 'none';
        return;
      }

      emptyEl.style.display = 'none';
      footerEl.style.display = '';
      if (scrollSections) scrollSections.style.display = '';
      shipBar.style.display = '';

      var totalSavings = 0;
      cart.items.forEach(function(item) {
        if (item.original_line_price > item.final_line_price) {
          totalSavings += item.original_line_price - item.final_line_price;
        }
      });

      // Render the SAME server-side markup the cart page uses, so the drawer can never
      // drift from it (grouping, cut notes, free-item styling, stock caps all come free).
      renderSharedItems();

      subtotalEl.textContent = formatMoney(cart.total_price);
      updateShipBar(cart.total_price);

      if (totalSavings > 0) {
        savingsEl.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><path d="M7 7h.01"/></svg> You save ' + formatMoney(totalSavings);
        savingsEl.style.display = '';
      } else {
        savingsEl.style.display = 'none';
      }

      updateDiscountPills(cart);
      updateScrollHint(cart);
      fetchUpsells(cart);
    }

    function refreshCart() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(renderItems)
        .catch(function() {});
    }

    function updateQty(key, qty) {
      var updates = {};
      updates[key] = qty;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function(r) { return r.json(); })
        .then(function(cart) { renderItems(cart); });
    }

    function updateDiscountPills(cart) {
      var discounts = cart.cart_level_discount_applications || [];
      var toggleText = 'Have a discount code?';
      if (discounts.length) {
        var pillsHtml = '<div class="cart-drawer__discount-pills">';
        discounts.forEach(function(d) {
          pillsHtml += '<span class="cd-discount-pill">' + d.title + ' −' + formatMoney(d.total_allocated_amount) + '</span>';
        });
        pillsHtml += '</div>';
        var existing = discountWrap.querySelector('.cart-drawer__discount-pills');
        if (existing) existing.remove();
        discountToggle.insertAdjacentHTML('beforebegin', pillsHtml);
        toggleText = 'Add another code';
      } else {
        var existing = discountWrap.querySelector('.cart-drawer__discount-pills');
        if (existing) existing.remove();
      }
      discountToggle.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><path d="M7 7h.01"/></svg> ' + toggleText;
    }

    function updateScrollHint(cart) {
      if (!scrollHint) return;
      var totalItems = cart.items.length;
      if (totalItems > 3 && body.scrollTop < 20) {
        var hidden = totalItems - 2;
        scrollHintText.textContent = 'Scroll for ' + hidden + ' more ' + (hidden === 1 ? 'item' : 'items');
        scrollHint.style.display = '';
      } else {
        scrollHint.style.display = 'none';
      }
    }

    if (body) {
      body.addEventListener('scroll', function() {
        if (scrollHint && body.scrollTop > 30) {
          scrollHint.style.display = 'none';
        }
      }, { passive: true });
    }

    function fetchUpsells(cart) {
      if (!cart.items.length) { upsellWrap.style.display = 'none'; return; }
      fetch('/recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=6&intent=related')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data.products || [];
          var cartHandles = {};
          cart.items.forEach(function(i) { cartHandles[i.handle] = true; });
          products = products.filter(function(p) { return !cartHandles[p.handle] && p.available; });
          if (!products.length) { upsellWrap.style.display = 'none'; return; }
          upsellWrap.style.display = '';
          var html = '';
          products.slice(0, 5).forEach(function(p) {
            var img = p.featured_image ? p.featured_image.replace(/(\.\w+)(\?|$)/, '_160x160$1$2') : '';
            var price = formatMoney(p.price);
            html += '<button type="button" class="cd-upsell-card" data-cd-upsell-qv="' + p.handle + '" data-cd-upsell-img="' + img + '">';
            html += '<img class="cd-upsell-card__img" src="' + img + '" alt="" loading="lazy">';
            html += '<p class="cd-upsell-card__name">' + p.title + '</p>';
            html += '<p class="cd-upsell-card__price">' + price + '</p>';
            html += '</button>';
          });
          upsellScroll.innerHTML = html;
        })
        .catch(function() { upsellWrap.style.display = 'none'; });
    }

    el.addEventListener('click', function(e) {
      if (e.target.closest('[data-cart-drawer-close]')) {
        close();
        return;
      }

      var removeBtn = e.target.closest('[data-cd-remove]');
      if (removeBtn) {
        var key = removeBtn.dataset.cdRemove;
        var row = removeBtn.closest('.cd-item');
        var title = row ? row.dataset.title : '';
        var imgSrc = row ? row.dataset.img : '';
        var handle = row ? row.dataset.handle : '';
        showRemovePopup(key, title, imgSrc, handle);
        return;
      }

      var upsellCard = e.target.closest('[data-cd-upsell-qv]');
      if (upsellCard) {
        var handle = upsellCard.dataset.cdUpsellQv;
        var img = upsellCard.dataset.cdUpsellImg || '';
        if (window.__qvOpen) window.__qvOpen(handle, img);
        return;
      }

      var qtyBtn = e.target.closest('[data-cd-qty]');
      if (qtyBtn) {
        var action = qtyBtn.dataset.cdQty;
        var key = qtyBtn.dataset.cdKey;
        var val = qtyBtn.closest('.cd-item__qty').querySelector('.cd-item__qty-val');
        var cur = parseInt(val.textContent) || 1;
        var newQty = action === 'plus' ? cur + 1 : Math.max(0, cur - 1);
        if (newQty === 0) {
          var row = qtyBtn.closest('.cd-item');
          var title = row ? row.dataset.title : '';
          var imgSrc = row ? row.dataset.img : '';
          var handle = row ? row.dataset.handle : '';
          showRemovePopup(key, title, imgSrc, handle);
          return;
        }
        val.textContent = newQty;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          updateQty(key, newQty);
        }, 350);
        return;
      }
    });

    if (popup) {
      popup.addEventListener('click', function(e) {
        if (e.target.closest('[data-cd-popup-close]')) {
          hideRemovePopup();
          return;
        }
      });

      popupRemove.addEventListener('click', function() {
        if (!pendingRemoveKey) return;
        var key = pendingRemoveKey;
        hideRemovePopup();
        var row = document.querySelector('.cd-item[data-key="' + key + '"]');
        if (row) row.classList.add('is-removing');
        updateQty(key, 0);
      });

      popupWishlist.addEventListener('click', function() {
        if (!pendingRemoveKey || !pendingRemoveHandle) return;
        var key = pendingRemoveKey;
        var handle = pendingRemoveHandle;
        var wlData = {
          handle: handle,
          title: popupTitle ? popupTitle.textContent : '',
          image: popupImg ? popupImg.src : ''
        };
        hideRemovePopup();
        if (window.__wl && typeof window.__wl.add === 'function') {
          window.__wl.add(wlData);
        } else {
          var wl = [];
          try { wl = JSON.parse(localStorage.getItem('fvs_wishlist') || '[]'); } catch(ex) {}
          var exists = wl.some(function(w) { return w && w.handle === handle; });
          if (!exists) {
            wl.push(wlData);
            localStorage.setItem('fvs_wishlist', JSON.stringify(wl));
          }
          var wlCount = document.querySelector('[data-wishlist-count]');
          if (wlCount) wlCount.textContent = wl.length;
        }
        var row = document.querySelector('.cd-item[data-key="' + key + '"]');
        if (row) row.classList.add('is-removing');
        updateQty(key, 0);
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (popup && popup.style.display !== 'none') { hideRemovePopup(); return; }
        if (el.classList.contains('is-open')) close();
      }
    });

    window.__cartDrawerOpen = open;
    window.__cartDrawerClose = close;
    window.__cartDrawerRefresh = refreshCart;
    // Unified add hook — in drawer mode, adding opens the drawer.
    window.__cartAdded = function() { open(); };

    document.addEventListener('cart:added', function() {
      open();
    });

    if (discountToggle && discountForm) {
      discountToggle.addEventListener('click', function() {
        var showing = discountForm.style.display !== 'none';
        discountForm.style.display = showing ? 'none' : '';
        if (!showing) discountInput.focus();
      });
    }

    if (discountApply && discountInput) {
      function applyDiscount() {
        var code = discountInput.value.trim();
        if (!code) return;
        discountApply.textContent = '...';
        sessionStorage.setItem('fvs_discount_attempt', code);
        close();
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      }
      discountApply.addEventListener('click', applyDiscount);
      discountInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); }
      });
    }
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(__initCartDrawer);
  } else {
    document.addEventListener('DOMContentLoaded', __initCartDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ladder-pricing-v2"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.getElementById('lp2');
    if (!box) return;

    var t2 = parseFloat(box.dataset.t2) || 0;
    var t3 = parseFloat(box.dataset.t3) || 0;
    var min3 = parseInt(box.dataset.min3, 10) || 3;

    function variantData() {
      var el = document.getElementById('lp2-variants');
      if (el) { try { return JSON.parse(el.textContent); } catch (e) {} }
      return [];
    }

    function mpu(sku) {
      if (!sku) return 1;
      var m = /-(\d+(?:\.\d+)?)M$/i.exec(sku);
      if (!m) return 1;
      var v = Number(m[1]);
      return isFinite(v) && v > 0 ? v : 1;
    }

    function currentVariant() {
      var form = document.getElementById('product-form');
      var inp = form ? form.querySelector('input[name="id"]') : null;
      if (!inp) return null;
      var vs = variantData();
      for (var i = 0; i < vs.length; i++) {
        if (String(vs[i].id) === String(inp.value)) return vs[i];
      }
      return null;
    }

    function money(sub) {
      return '₹' + Math.round(sub / 100).toLocaleString('en-IN');
    }

    function rateFor(qty, base) {
      if (qty >= min3) return Math.round(base * (100 - t3) / 100);
      if (qty === 2) return Math.round(base * (100 - t2) / 100);
      return base;
    }

    // "price for 1 meter" reference: the CURRENT variant if it's already whole-meter,
    // else the cheapest^H^H first whole-meter sibling in its own fabric group (same
    // option1+option2) — NOT just the first whole-meter variant anywhere on the
    // product, which broke row prices whenever a product has multiple fabric groups
    // at different price points (e.g. switching Japan Satin ₹319 -> Pashmina ₹329
    // kept showing ₹319, because it always grabbed whichever group listed first).
    function baseVariant(v) {
      if (v && v.price && mpu(v.sku) === 1) return v;
      var vs = variantData();
      if (v) {
        var key = groupKey(v);
        for (var i = 0; i < vs.length; i++) {
          if (vs[i].price && mpu(vs[i].sku) === 1 && groupKey(vs[i]) === key) return vs[i];
        }
      }
      for (var j = 0; j < vs.length; j++) {
        if (vs[j].price && mpu(vs[j].sku) === 1) return vs[j];
      }
      return null;
    }

    // width siblings: same fabric (option1+option2), differ only by width (option3) —
    // same grouping key the variant selector (vsv2) uses
    function groupKey(v) {
      return (v.option1 || '') + '|||' + (v.option2 || '');
    }
    // metafield first, option3 as fallback — same chain the variant selector uses
    // (wv.width || wv.option3); metafield-only missed products that carry width as
    // a plain variant option instead of a custom.width metafield.
    function widthOf(v) {
      return (v && (v.width || v.option3)) || '';
    }
    function widthGroup(v) {
      var vs = variantData();
      var key = groupKey(v);
      return vs.filter(function (o) {
        return groupKey(o) === key && mpu(o.sku) === 1 && widthOf(o);
      });
    }

    var specEl = document.getElementById('lp2-spec');
    var qualityEl = document.getElementById('lp2-quality');
    var fabricEl = document.getElementById('lp2-fabric');
    var widthsEl = document.getElementById('lp2-widths');

    function switchToVariant(vid) {
      // delegate to the variant selector's own width chip when present — it owns
      // price/image/URL/ATC-label updates that this card doesn't duplicate
      var vsChip = document.querySelector('.vsv2__width-chip[data-variant-id="' + vid + '"]');
      if (vsChip) { vsChip.click(); return; }
      // fallback (no variant selector on the page): switch the input directly —
      // updates this card and other v2 components, but not price/image/URL
      var inp = document.getElementById('variant-id');
      if (!inp) return;
      inp.value = vid;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function render() {
      var v = currentVariant();
      var bv = baseVariant(v);
      if (!v || !bv) { box.hidden = true; return; }

      var pieceMpu = mpu(v.sku);
      var fractional = pieceMpu !== 1;
      box.classList.toggle('lp2--readonly', fractional);

      if (qualityEl) {
        var q = (v.quality || '').trim();
        qualityEl.textContent = q.toUpperCase();
        qualityEl.hidden = !q;
      }
      if (fabricEl && v.fabric) fabricEl.textContent = v.fabric;

      // dedupe by unique width VALUE, not variant count — a group with 2 variants
      // sharing the same option3/width text (e.g. a duplicate SKU) must still count
      // as one width, not trigger a two-button row that looks identical
      var grp = widthGroup(v);
      var uniqueByWidth = {};
      var uniqueWidths = [];
      grp.forEach(function (wv) {
        var w = widthOf(wv);
        if (!(w in uniqueByWidth)) {
          uniqueByWidth[w] = wv;
          uniqueWidths.push(wv);
        } else if (String(wv.id) === String(v.id)) {
          // keep the currently-selected variant's own id as the representative
          // for its width, so the active pill matches the real selection
          var idx = uniqueWidths.indexOf(uniqueByWidth[w]);
          uniqueByWidth[w] = wv;
          if (idx !== -1) uniqueWidths[idx] = wv;
        }
      });

      if (widthsEl) {
        if (uniqueWidths.length > 1) {
          widthsEl.innerHTML = '<span class="lp2__widths-label">Width:</span>';
          uniqueWidths.forEach(function (wv) {
            var chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'lp2__width-chip' + (String(wv.id) === String(v.id) ? ' is-active' : '');
            chip.textContent = widthOf(wv);
            chip.addEventListener('click', function () { switchToVariant(wv.id); });
            widthsEl.appendChild(chip);
          });
          widthsEl.hidden = false;
        } else {
          widthsEl.hidden = true;
        }
      }

      if (specEl) {
        var parts = [];
        if (v.sku && v.sku.indexOf('SHADOW') === -1) parts.push(v.sku);
        if (v.gsm) parts.push(v.gsm + ' GSM');
        if (uniqueWidths.length <= 1 && widthOf(v)) parts.push(widthOf(v));
        specEl.textContent = parts.join(' · ');
      }

      var base = bv.price;
      var p1 = box.querySelector('[data-lp-price="1"]');
      var p2 = box.querySelector('[data-lp-price="2"]');
      var p3 = box.querySelector('[data-lp-price="3"]');
      if (p1) p1.innerHTML = money(base) + '<small>/m</small>';
      if (p2) p2.innerHTML = money(rateFor(2, base)) + '<small>/m</small>';
      if (p3) p3.innerHTML = money(rateFor(min3, base)) + '<small>/m</small>';

      var s2 = box.querySelector('[data-lp-save="2"]');
      var s3 = box.querySelector('[data-lp-save="3"]');
      if (s2) s2.textContent = t2 + '% off';
      if (s3) s3.textContent = t3 + '% off';

      var mi = document.getElementById('meter-input');
      var qty = mi ? (parseInt(mi.value, 10) || 1) : 1;
      var form = document.getElementById('product-form');
      var pending = form ? parseFloat(form.dataset.qtyPresetPendingMeters) : NaN;
      pending = isFinite(pending) && pending > 0 ? pending : 0;
      var effMeters = pending > 0 ? pending : qty * pieceMpu;

      box.querySelectorAll('.lp2__row').forEach(function (r) {
        var rq = parseInt(r.dataset.lpQty, 10);
        var active =
          (rq === 1 && effMeters >= 1 && effMeters < 2) ||
          (rq === 2 && effMeters >= 2 && effMeters < min3) ||
          (rq >= min3 && effMeters >= min3);
        r.classList.toggle('is-active', active);
      });

      box.hidden = false;
    }

    box.addEventListener('click', function (e) {
      if (box.classList.contains('lp2--readonly')) return;
      var row = e.target.closest('.lp2__row');
      if (!row) return;
      var mi = document.getElementById('meter-input');
      if (!mi) return;
      mi.value = row.dataset.lpQty;
      mi.dispatchEvent(new Event('change', { bubbles: true }));
      render();
    });

    document.addEventListener('change', function (e) {
      if (e.target && (e.target.id === 'meter-input' || e.target.name === 'id')) render();
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('#qty-minus, #qty-plus')) setTimeout(render, 0);
      if (e.target.closest('[data-quantity-presets-block]')) {
        setTimeout(render, 0);
        setTimeout(render, 700);
      }
    });

    render();

    // ── daily-offer countdown against validUntil (ISO w/ +05:30 offset — Date parses IST) ──
    // merchant control: "always" or "peak_only" (only when quantity_ladder_config.isPeak is true)
    (function () {
      var cdEl = document.getElementById('lp2-countdown');
      var raw = box.getAttribute('data-valid-until');
      var countdownMode = box.getAttribute('data-countdown-mode') || 'always';
      var isPeak = box.getAttribute('data-is-peak') === 'true';
      if (!cdEl || !raw) return;
      if (countdownMode === 'peak_only' && !isPeak) { cdEl.hidden = true; return; }
      var validUntil = new Date(raw);
      if (isNaN(validUntil.getTime())) return;
      function pad2(n) { return n < 10 ? '0' + n : '' + n; }
      var timer = null;
      function tick() {
        var diff = validUntil.getTime() - Date.now();
        if (diff <= 0) { cdEl.hidden = true; if (timer) clearInterval(timer); return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        cdEl.textContent = 'Offer ends in ' + (h > 0 ? h + 'h ' + pad2(m) + 'm ' : m + 'm ') + pad2(s) + 's';
        cdEl.hidden = false;
      }
      tick();
      timer = setInterval(tick, 1000);
    })();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ladder-pricing"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.getElementById('ladder-pricing');
    if (!box) return;

    var t2 = parseFloat(box.dataset.t2) || 0;
    var t3 = parseFloat(box.dataset.t3) || 0;
    var min3 = parseInt(box.dataset.min3, 10) || 3;

    // ── daily-offer countdown against validUntil (ISO w/ +05:30 offset — Date parses IST) ──
    // merchant control: "always" or "peak_only" (only when quantity_ladder_config.isPeak is true)
    (function () {
      var cdEl = document.getElementById('ladder-pricing-countdown');
      var raw = box.getAttribute('data-valid-until');
      var countdownMode = box.getAttribute('data-countdown-mode') || 'always';
      var isPeak = box.getAttribute('data-is-peak') === 'true';
      if (!cdEl || !raw) return;
      if (countdownMode === 'peak_only' && !isPeak) { cdEl.hidden = true; return; }
      var validUntil = new Date(raw);
      if (isNaN(validUntil.getTime())) return;
      function pad2(n) { return n < 10 ? '0' + n : '' + n; }
      var timer = null;
      function tick() {
        var diff = validUntil.getTime() - Date.now();
        if (diff <= 0) { cdEl.hidden = true; if (timer) clearInterval(timer); return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        cdEl.textContent = 'Offer ends in ' + (h > 0 ? h + 'h ' + pad2(m) + 'm ' : m + 'm ') + pad2(s) + 's';
        cdEl.hidden = false;
      }
      tick();
      timer = setInterval(tick, 1000);
    })();

    function variantData() {
      var el = document.getElementById('ladder-pricing-variants');
      if (el) { try { return JSON.parse(el.textContent); } catch (e) {} }
      return [];
    }

    function mpu(sku) {
      if (!sku) return 1;
      var m = /-(\d+(?:\.\d+)?)M$/i.exec(sku);
      if (!m) return 1;
      var v = Number(m[1]);
      return isFinite(v) && v > 0 ? v : 1;
    }

    function currentVariant() {
      var form = document.getElementById('product-form');
      var inp = form ? form.querySelector('input[name="id"]') : null;
      if (!inp) return null;
      var vs = variantData();
      for (var i = 0; i < vs.length; i++) {
        if (String(vs[i].id) === String(inp.value)) return vs[i];
      }
      return null;
    }

    function money(sub) {
      // whole-rupee display per the discount-tier instruction
      return '₹' + Math.round(sub / 100).toLocaleString('en-IN');
    }

    function rateFor(qty, base) {
      if (qty >= min3) return Math.round(base * (100 - t3) / 100);
      if (qty === 2) return Math.round(base * (100 - t2) / 100);
      return base;
    }

    function pageQty() {
      var mi = document.getElementById('meter-input');
      var q = mi ? parseInt(mi.value, 10) : 1;
      return isNaN(q) || q < 1 ? 1 : q;
    }

    function pendingMeters() {
      // calculator presets that don't switch variants store the true length here
      var form = document.getElementById('product-form');
      if (!form) return 0;
      var m = parseFloat(form.dataset.qtyPresetPendingMeters);
      return isFinite(m) && m > 0 ? m : 0;
    }

    function groupKey(v) {
      return (v.option1 || '') + '|||' + (v.option2 || '');
    }

    // "price for 1 meter" reference: the CURRENT variant if already whole-meter, else
    // the first whole-meter sibling in its own fabric group — not just the first
    // whole-meter variant anywhere on the product (broke rates across fabric groups
    // at different price points).
    function baseVariant(v) {
      if (v && v.price && mpu(v.sku) === 1) return v;
      var vs = variantData();
      if (v) {
        var key = groupKey(v);
        for (var i = 0; i < vs.length; i++) {
          if (vs[i].price && mpu(vs[i].sku) === 1 && groupKey(vs[i]) === key) return vs[i];
        }
      }
      for (var j = 0; j < vs.length; j++) {
        if (vs[j].price && mpu(vs[j].sku) === 1) return vs[j];
      }
      return null;
    }

    function render() {
      var v = currentVariant();
      var bv = baseVariant(v);
      if (!v || !bv) { box.hidden = true; return; }

      // fractional cut piece selected (e.g. via the calculator presets): keep the
      // cards visible as reference, highlight by EFFECTIVE meters, but make them
      // display-only and drop the total line (piece pricing is its own number)
      var pieceMpu = mpu(v.sku);
      var fractional = pieceMpu !== 1;
      box.classList.toggle('ladder-pricing--readonly', fractional);

      var base = bv.price;
      var p1 = box.querySelector('[data-lp-price="1"]');
      var p2 = box.querySelector('[data-lp-price="2"]');
      var p3 = box.querySelector('[data-lp-price="3"]');
      if (p1) p1.innerHTML = money(base) + '<small>/m</small>';
      if (p2) p2.innerHTML = money(rateFor(2, base)) + '<small>/m</small>';
      if (p3) p3.innerHTML = money(rateFor(min3, base)) + '<small>/m</small>';

      // absolute savings alongside the percent (per meter)
      var s2 = box.querySelector('[data-lp-save="2"]');
      var s3 = box.querySelector('[data-lp-save="3"]');
      if (s2) s2.textContent = 'Save ' + t2 + '% · ' + money(base - rateFor(2, base)) + '/m';
      if (s3) s3.textContent = 'Save ' + t3 + '% · ' + money(base - rateFor(min3, base)) + '/m';

      var qty = pageQty();
      var pending = pendingMeters();
      var effMeters = pending > 0 ? pending : qty * pieceMpu;
      // range-based highlight: 1 ≤ eff < 2 → card 1; 2 ≤ eff < min3 → card 2; eff ≥ min3 → card 3
      box.querySelectorAll('.ladder-pricing__card').forEach(function (c) {
        var cq = parseInt(c.dataset.lpQty, 10);
        var active =
          (cq === 1 && effMeters >= 1 && effMeters < 2) ||
          (cq === 2 && effMeters >= 2 && effMeters < min3) ||
          (cq >= min3 && effMeters >= min3);
        c.classList.toggle('is-active', active);
      });

      function effFmt(n) {
        n = Math.round(n * 10) / 10;
        return n % 1 === 0 ? String(Math.round(n)) : String(n);
      }

      var totalEl = document.getElementById('ladder-pricing-total');
      if (totalEl) {
        if (!v.price || v.price <= 0) { totalEl.hidden = true; totalEl.innerHTML = ''; }
        else {
        totalEl.hidden = false;
        // percent off the ACTUAL selected variant's line total (mirrors the Function),
        // labeled in effective meters so fractional pieces read correctly
        var pct = effMeters >= min3 ? t3 : (effMeters >= 2 ? t2 : 0);
        var orig = pending > 0 ? Math.round(base * pending) : v.price * qty;
        var total = Math.round(orig * (100 - pct) / 100);
        var label = 'Selected: ' + effFmt(effMeters) + ' meter' + (effMeters === 1 ? '' : 's');
        if (total < orig) {
          totalEl.innerHTML = label + ' = <s>' + money(orig) + '</s> <strong>' + money(total) +
            '</strong> · you save ' + money(orig - total);
        } else {
          totalEl.innerHTML = label + ' = <strong>' + money(total) + '</strong>';
        }
        }
      }
      box.hidden = false;
    }

    // card click → set the quantity stepper (everything else syncs via its listeners)
    box.addEventListener('click', function (e) {
      // display-only while a fractional piece variant is selected (calculator owns qty)
      if (box.classList.contains('ladder-pricing--readonly')) return;
      var card = e.target.closest('.ladder-pricing__card');
      if (!card) return;
      var mi = document.getElementById('meter-input');
      if (!mi) return;
      mi.value = card.dataset.lpQty;
      mi.dispatchEvent(new Event('change', { bubbles: true }));
      render();
      // 3+ card: pulse the stepper so it's obvious quantity can go higher
      if (parseInt(card.dataset.lpQty, 10) >= min3) {
        var stepper = mi.closest('.product-quantity__stepper') || mi.parentElement;
        if (stepper) {
          stepper.classList.remove('ladder-pricing-pulse');
          void stepper.offsetWidth;
          stepper.classList.add('ladder-pricing-pulse');
          setTimeout(function () { stepper.classList.remove('ladder-pricing-pulse'); }, 1300);
        }
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target && (e.target.id === 'meter-input' || e.target.name === 'id')) render();
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('#qty-minus, #qty-plus')) setTimeout(render, 0);
      // calculator writes its pending length AFTER dispatching change events —
      // re-read on the next tick for any interaction inside the presets block
      if (e.target.closest('[data-quantity-presets-block]')) {
        setTimeout(render, 0);
        setTimeout(render, 700);
      }
    });

    render();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__quick-view');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-product-url').split('/products/')[1].split('?')[0];
      var cardImg = btn.closest('.product-card__media').querySelector('.product-card__img--primary');
      var imgSrc = cardImg ? cardImg.src : '';
      var extraData = {
        meta: btn.getAttribute('data-card-meta') || '',
        reviewAvg: parseInt(btn.getAttribute('data-review-avg')) || 0,
        reviewCount: parseInt(btn.getAttribute('data-review-count')) || 0,
        rateUnit: btn.getAttribute('data-rate-unit') || ''
      };
      if (window.__qvOpen) {
        window.__qvOpen(handle, imgSrc, extraData);
      } else {
        window.location.href = btn.getAttribute('data-product-url');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view-modal"] && !Shopify.designMode) return;
  try {
    function __initQuickView() {
    if (window.__qvOpen) return;

    var qvModal = document.getElementById('qv-modal');
    var qvOverlay = document.getElementById('qv-overlay');
    var qvClose = document.getElementById('qv-close');
    var qvImg = document.getElementById('qv-img');
    var qvTitle = document.getElementById('qv-title');
    var qvPrice = document.getElementById('qv-price');
    var qvQtyInput = document.getElementById('qv-qty-input');
    var qvAtc = document.getElementById('qv-atc');
    var qvMeta = document.getElementById('qv-meta');
    var qvStars = document.getElementById('qv-stars');
    var qvViewLink = document.getElementById('qv-view-link');
    var qvSelectedVariant = null;
    var qvRateUnit = '';

    if (!qvModal) return;

    function qvOpenModal() {
      qvModal.classList.add('is-open');
      qvOverlay.classList.add('is-open');
      qvModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function qvCloseModal() {
      qvModal.classList.remove('is-open');
      qvOverlay.classList.remove('is-open');
      qvModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      qvSelectedVariant = null;
    }

    if (qvClose) qvClose.addEventListener('click', qvCloseModal);
    if (qvOverlay) qvOverlay.addEventListener('click', qvCloseModal);

    function qvFormatMoney(cents) {
      return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function qvUpdatePrice() {
      if (!qvSelectedVariant) return;
      var html = '';
      if (qvSelectedVariant.compare_at_price && qvSelectedVariant.compare_at_price > qvSelectedVariant.price) {
        html += '<span class="qv-modal__price-compare">' + qvFormatMoney(qvSelectedVariant.compare_at_price) + '</span>';
      }
      html += '<span>' + qvFormatMoney(qvSelectedVariant.price) + '</span>';
      if (qvRateUnit) {
        html += ' <span class="qv-modal__price-unit">/ ' + qvRateUnit + '</span>';
      }
      qvPrice.innerHTML = html;
      qvAtc.disabled = !qvSelectedVariant.available;
      qvAtc.textContent = qvSelectedVariant.available ? 'Add to Cart' : 'Sold Out';
    }

    function qvRenderStars(avg, count) {
      if (!count) { qvStars.innerHTML = ''; return; }
      var html = '';
      for (var i = 1; i <= 5; i++) {
        var full = i * 10;
        var half = full - 5;
        if (avg >= full) {
          html += '<svg width="13" height="13" viewBox="0 0 24 24" fill="var(--color-gold)" stroke="var(--color-gold)" stroke-width="1.5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg>';
        } else if (avg >= half) {
          html += '<svg width="13" height="13" viewBox="0 0 24 24" stroke="var(--color-gold)" stroke-width="1.5" fill="none"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z" fill="url(#qv-half)"/><defs><linearGradient id="qv-half"><stop offset="50%" stop-color="var(--color-gold)"/><stop offset="50%" stop-color="transparent"/></linearGradient></defs></svg>';
        } else {
          html += '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--color-gold)" stroke-width="1.5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg>';
        }
      }
      html += '<span class="qv-modal__stars-count">(' + count + ')</span>';
      qvStars.innerHTML = html;
    }

    document.getElementById('qv-qty-minus').addEventListener('click', function() {
      var v = parseInt(qvQtyInput.value) || 1;
      if (v > 1) qvQtyInput.value = v - 1;
    });
    document.getElementById('qv-qty-plus').addEventListener('click', function() {
      var v = parseInt(qvQtyInput.value) || 1;
      qvQtyInput.value = v + 1;
    });

    qvAtc.addEventListener('click', function() {
      if (!qvSelectedVariant || !qvSelectedVariant.available) return;
      qvAtc.classList.add('is-adding');
      qvAtc.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: qvSelectedVariant.id, quantity: parseInt(qvQtyInput.value) || 1 })
      })
      .then(function(r) { return r.json().then(function(data) { return { ok: r.ok, data: data }; }); })
      .then(function(res) {
        if (!res.ok) {
          // Shopify blocked it (usually not enough stock) — surface its message.
          qvAtc.classList.remove('is-adding');
          qvAtc.textContent = 'Add to Cart';
          var desc = (res.data && (res.data.description || res.data.message)) || 'Not enough stock available';
          var errEl = document.getElementById('qv-add-error');
          if (!errEl) {
            errEl = document.createElement('div');
            errEl.id = 'qv-add-error';
            errEl.style.cssText = 'font-size:0.8125rem;color:#b23b3b;margin-top:0.5rem;text-align:center;';
            qvAtc.parentNode.appendChild(errEl);
          }
          errEl.textContent = desc;
          return;
        }
        var errClear = document.getElementById('qv-add-error');
        if (errClear) errClear.textContent = '';
        qvAtc.textContent = 'Added!';
        setTimeout(function() {
          qvAtc.classList.remove('is-adding');
          qvCloseModal();
          var drawerEl = document.getElementById('cart-drawer');
          if (drawerEl && drawerEl.classList.contains('is-open') && window.__cartDrawerRefresh) {
            window.__cartDrawerRefresh();
          } else if (window.__cartAdded) {
            window.__cartAdded(res.data);
          } else {
            var countEl = document.querySelector('.header__cart-count');
            if (countEl) {
              fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
                countEl.textContent = cart.item_count;
                countEl.style.display = cart.item_count > 0 ? '' : 'none';
              });
            }
          }
        }, 600);
      })
      .catch(function() {
        qvAtc.classList.remove('is-adding');
        qvAtc.textContent = 'Add to Cart';
      });
    });

    window.__qvOpen = function(handle, imgSrc, extra) {
      extra = extra || {};
      qvImg.src = imgSrc || '';
      qvTitle.textContent = '';
      qvViewLink.href = '/products/' + handle;
      qvMeta.textContent = extra.meta || '';
      qvRenderStars(extra.reviewAvg, extra.reviewCount);
      qvRateUnit = extra.rateUnit || '';
      document.getElementById('qv-qty-unit').textContent = qvRateUnit ? qvRateUnit : '';
      qvPrice.innerHTML = '';
      qvQtyInput.value = 1;
      qvAtc.textContent = 'Add to Cart';
      qvAtc.classList.remove('is-adding');
      qvAtc.disabled = false;
      qvOpenModal();

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          qvTitle.textContent = product.title;
          if (product.featured_image) {
            qvImg.src = product.featured_image.replace(/(\.[^.]+)$/, '_400x$1');
          }
          var firstAvailable = product.variants.find(function(v) { return v.available; }) || product.variants[0];
          qvSelectedVariant = firstAvailable;
          qvUpdatePrice();
        });
    };
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(__initQuickView);
  } else {
    document.addEventListener('DOMContentLoaded', __initQuickView);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-engine"] && !Shopify.designMode) return;
  try {
    function __initWishlist() {
    var KEY = 'fvs_wishlist';

    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; }
      catch(e) { return []; }
    }

    function saveWishlist(list) {
      var payload = JSON.stringify(list);
      try {
        localStorage.setItem(KEY, payload);
      } catch (e) {
        // Storage full (third-party trackers can eat the whole quota) —
        // drop known junk keys and retry once so the wishlist keeps working.
        try {
          localStorage.removeItem('stape_events');
          localStorage.removeItem('__uc_site');
          localStorage.setItem(KEY, payload);
        } catch (e2) { /* still full — give up silently */ }
      }
      updateBadges();
    }

    function isInWishlist(handle) {
      return getWishlist().some(function(item) { return item.handle === handle; });
    }

    function addToWishlist(data) {
      var list = getWishlist();
      if (!list.some(function(item) { return item.handle === data.handle; })) {
        list.push(data);
        saveWishlist(list);
      }
    }

    function updateItem(handle, updates) {
      var list = getWishlist();
      var changed = false;
      list.forEach(function(item) {
        if (item.handle === handle) {
          Object.keys(updates).forEach(function(k) {
            if (updates[k] && !item[k]) {
              item[k] = updates[k];
              changed = true;
            }
          });
        }
      });
      if (changed) localStorage.setItem(KEY, JSON.stringify(list));
    }

    function removeFromWishlist(handle) {
      var list = getWishlist().filter(function(item) { return item.handle !== handle; });
      saveWishlist(list);
    }

    function updateBadges() {
      var count = getWishlist().length;
      document.querySelectorAll('.wl-badge').forEach(function(badge) {
        badge.textContent = count;
        badge.classList.toggle('is-visible', count > 0);
      });
    }

    function showToast(msg) {
      var toast = document.getElementById('wl-toast');
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('is-visible');
      clearTimeout(toast._timer);
      toast._timer = setTimeout(function() {
        toast.classList.remove('is-visible');
      }, 2000);
    }

    function getCardData(card) {
      var link = card.querySelector('.product-card__link');
      var titleEl = card.querySelector('.product-card__title');
      var imgEl = card.querySelector('.product-card__img--primary');
      var priceEl = card.querySelector('.product-card__price--current');
      var compareEl = card.querySelector('.product-card__price--compare');
      var unitEl = card.querySelector('.product-card__price-unit');
      var meta = card.getAttribute('data-wl-meta') || '';
      var rateUnit = card.getAttribute('data-wl-unit') || '';
      var handle = link ? link.getAttribute('href').split('/products/')[1] : '';
      if (handle) handle = handle.split('?')[0].split('#')[0];

      return {
        handle: handle,
        title: titleEl ? titleEl.textContent.trim() : '',
        img: imgEl ? imgEl.src : '',
        price: priceEl ? priceEl.textContent.trim() : '',
        comparePrice: compareEl ? compareEl.textContent.trim() : '',
        url: link ? link.getAttribute('href') : '/products/' + handle,
        meta: meta,
        rateUnit: rateUnit
      };
    }

    function initHearts() {
      document.querySelectorAll('.product-card').forEach(function(card) {
        if (card.querySelector('.wl-heart')) return;
        var link = card.querySelector('.product-card__link');
        if (!link) return;
        var handle = link.getAttribute('href').split('/products/')[1];
        if (!handle) return;
        handle = handle.split('?')[0].split('#')[0];
        var media = card.querySelector('.product-card__media');
        if (!media) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wl-heart';
        btn.setAttribute('aria-label', 'Add to wishlist');
        btn.setAttribute('data-wl-handle', handle);
        btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>';

        if (isInWishlist(handle)) {
          btn.classList.add('is-active');
          var meta = card.getAttribute('data-wl-meta') || '';
          var rateUnit = card.getAttribute('data-wl-unit') || '';
          if (meta || rateUnit) {
            updateItem(handle, { meta: meta, rateUnit: rateUnit });
          }
        }

        media.appendChild(btn);
      });
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.wl-heart');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var handle = btn.getAttribute('data-wl-handle');
      var card = btn.closest('.product-card');

      if (isInWishlist(handle)) {
        removeFromWishlist(handle);
        btn.classList.remove('is-active');
        showToast('Removed from wishlist');
      } else {
        var data = getCardData(card);
        addToWishlist(data);
        btn.classList.add('is-active');
        showToast('Added to wishlist');
        var wlIcon = document.querySelector('.header__wl-btn');
        var cardImg = card.querySelector('.product-card__img--primary');
        if (wlIcon && cardImg) flyTo(btn, wlIcon, cardImg.src);
      }
    });

    function flyTo(sourceEl, destEl, imgSrc) {
      if (!sourceEl || !destEl || !imgSrc) return;
      var sR = sourceEl.getBoundingClientRect();
      var dR = destEl.getBoundingClientRect();
      var sx = sR.left + sR.width / 2;
      var sy = sR.top + sR.height / 2;
      var dx = dR.left + dR.width / 2;
      var dy = dR.top + dR.height / 2;

      var el = document.createElement('div');
      el.className = 'fly-item';
      el.style.setProperty('--fly-w', Math.min(sR.width, 80) + 'px');
      el.style.setProperty('--fly-h', Math.min(sR.height, 100) + 'px');
      el.style.setProperty('--fly-sx', sx + 'px');
      el.style.setProperty('--fly-sy', sy + 'px');
      el.style.setProperty('--fly-tx', (dx - sx) + 'px');
      el.style.setProperty('--fly-ty', (dy - sy) + 'px');
      el.style.backgroundImage = 'url(' + imgSrc + ')';
      document.body.appendChild(el);

      el.addEventListener('animationend', function() { el.remove(); });
      setTimeout(function() { el.remove(); }, 800);
    }

    window.__wl = {
      get: getWishlist,
      add: addToWishlist,
      remove: removeFromWishlist,
      isIn: isInWishlist,
      updateBadges: updateBadges,
      initHearts: initHearts,
      updateItem: updateItem
    };

    window.__flyTo = flyTo;

    updateBadges();
    initHearts();
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(__initWishlist);
  } else {
    document.addEventListener('DOMContentLoaded', __initWishlist);
  }
  } catch(e) { console.error(e); }
})();

})();
